import { format, parseISO } from 'date-fns';
import { CouponScopeLabels } from '../../../api/payments/coupons/domain/labels';

export function formatExpiresAt(expiresAt) {
  if (!expiresAt) return 'Sem data de expiração';
  return format(parseISO(expiresAt), 'dd/MM/yyyy');
}

export function formatCycleRange(fromCycle, toCycle) {
  const from = fromCycle == null ? 1 : Number(fromCycle);
  if (toCycle === null || toCycle === undefined || toCycle === '') {
    return from <= 1 ? 'Todos os ciclos' : `A partir do ciclo ${from}`;
  }
  const to = Number(toCycle);
  return `De ${from} até ${to}`;
}

export function formatCouponCode(value) {
  return (value || '')
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toUpperCase()
    .replace(/\s+/g, '_')
    .replace(/[^A-Z0-9_-]/g, '');
}

export function formatAppliesTo(coupon) {
  const discounts = coupon?.rules ?? [];
  if (!discounts.length) {
    return '-';
  }
  return discounts.reduce((acc, discount) => {
    const label = CouponScopeLabels[discount.scope];
    if (!label) return acc;
    return acc.length ? acc.concat(' - ', label) : acc.concat(label);
  }, '');
}

// Valor de uma regra (rule) de desconto — %/R$ — não confundir com
// formatDiscount, que lê um valor plano no próprio cupom (formato legado).
export function formatRuleValue(rule) {
  const value = rule.value;
  const valueType = rule.valueType ?? rule.value_type;
  if (value === undefined || value === null || value === '') return '-';
  return valueType === 'PERCENT'
    ? `${value}%`
    : `R$ ${Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      })}`;
}

export function formatDiscount(coupon) {
  const value = coupon.discountValue ?? coupon.value;
  const valueType = coupon.discountValueType ?? coupon.valueType;
  if (value === undefined || value === null) return '-';
  return valueType === 'PERCENT' ? `${value}%` : `R$${value}`;
}

export function getInitialParams(search) {
  const params = new URLSearchParams(search);
  const page = Number(params.get('page')) || 1;
  const perPage = Number(params.get('perPage')) || 10;
  const code = params.get('code') || '';
  const activeOnly = params.get('active') !== 'false';
  return { page, perPage, code, activeOnly };
}
